import { Injectable,OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class GlobalsService {


  constructor(private storage: LocalStorageService) { } 

  
  ngOnInit() {

    this.refrescar();
  }

  refrescar(){
    let usuario= JSON.parse(localStorage.getItem('sesion'));
  }

  /**
   * Obtiene la compañia de la sesion 
   */
  ObtenerCompania():string{

    let session = JSON.parse(atob(this.storage.retrieve('sesion')));

    return session.idCompania;
  }

/**
 * Obtiene la latitud de la compañia de la sesion
 */
  ObtenerLatitudCompania():string{

    let session = JSON.parse(atob(this.storage.retrieve('sesion')));

    return session.latitud;
  }

/**
 * Obtiene la longitud de la compañia de la sesion
 */
  ObtenerLongitudCompania():string{

    let session = JSON.parse(atob(this.storage.retrieve('sesion')));

    return session.longitud;
  }


}